import { Box, useTheme } from "@material-ui/core";
import Adjust from "apps/platform-client/client/src/components/icons/Adjust";
import { ReactElement } from "react";
import LyfeTooltip from "apps/platform-client/client/src/components/LyfeTooltip";
import AdjustmentTooltip from "apps/platform-client/client/src/components/AdjustmentTooltip";

export default function AdjustedAmountOrRateColumns(props: {
	adjustedAmount: number;
	adjustedRate: number;
	adjustedBy: string;
	adjustmentComment?: string;
	lastAdjustedAt: string;
	text?: string;
	tooltip?: string | ReactElement;
	wasAdjustedBefore: boolean;
	originalAmount: number;
	currency?: string;
	canUserViewFinancials: boolean;
}) {
	const { palette } = useTheme();
	const { text } = props;

	return (
		<LyfeTooltip placement="left" maxWidth="500px" title={<AdjustmentTooltip {...props} />}>
			<Box justifyContent="flex-end" display="flex" alignItems="center">
				<span style={{ lineHeight: "12px" }}>{<Adjust fill={palette.grey[900]} />}</span>
				<span style={{ maxWidth: 300, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontWeight: 600 }}>
					{text}
				</span>
			</Box>
		</LyfeTooltip>
	);
}
